import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Notebook } from "@learningblocks/simulations/shared-components";
import { ProtocolOptions } from "@learningblocks/simulation-engine";
import { ProgressBarBlock } from "@learningblocks/simulations/hotspot-sim-components";

export function ProtocolSectionContentComponent(props) {
  const {
    title,
    description,
    usingNewDesignSystem,
    maxProgress,
    currentProgress,
    progress,
  } = props;
  return (
    <>
      <Notebook.IndexBlock
        className={`book_index${usingNewDesignSystem ? " new-design-system" : ""}`}
      >
        <Notebook.Header
          className={`book_index_header${usingNewDesignSystem ? " hotspot_navbar_header" : ""}`}
        >
          {usingNewDesignSystem ? (
            <ProgressBarBlock
              className="index-titleBlock"
              title={title === "" ? description : title}
              maxProgress={maxProgress}
              currentProgress={currentProgress}
              progress={progress}
              menuList={[]}
            />
          ) : (
            <>
              <Notebook.TitleBlock
                className="index-titleBlock"
                title={title}
                text={description}
                ariaLabel="Lab notebook section heading."
              />
              <Notebook.GlossaryButton />
            </>
          )}
        </Notebook.Header>
        <ProtocolOptions />
      </Notebook.IndexBlock>
    </>
  );
}

ProtocolSectionContentComponent.propTypes = {
  /**
   * Details of currently active menu in menu list
   */
  currentMenu: PropTypes.shape({
    /**
     * Index of menu
     */
    number: PropTypes.number,
    /**
     * Title of menu
     */
    title: PropTypes.string,
    /**
     * Value of menu
     */
    value: PropTypes.string,
  }),
  /**
   * Current progress value
   */
  currentProgress: PropTypes.number,
  /**
   * Description to be displayed in Notebook Header
   */
  description: PropTypes.string,
  /**
   * Function to go to next section
   */
  goToSection: PropTypes.func,
  /**
   * Maximum progress value
   */
  maxProgress: PropTypes.number,
  /**
   * Value for next-in-line menu
   */
  nextMenuValue: PropTypes.oneOf([
    "CONTEXT",
    "TECHNIQUES",
    "DESIGN",
    "PROTOCOL",
    "PROBLEM_SOLVING",
    "RESULTS",
    "REFLECTION",
    "TROUBLESHOOTING",
    "NONE",
  ]),
  /**
   * Drawer Icon
   */
  notebookDrawerIcon: PropTypes.node,
  /**
   * function to invoke on clicking info icon on Notebook section menu
   */
  onClickInfo: PropTypes.func,
  /**
   * Progress percentage value
   */
  progress: PropTypes.number,
  /**
   * Function to set new isNotebookVisible value
   */
  setNotebookVisible: PropTypes.func,
  /**
   * Title of the Content to display at header
   */
  title: PropTypes.string,
  /**
   * Flag to use new design system with ProgressBarBlock
   */
  usingNewDesignSystem: PropTypes.bool,
};

ProtocolSectionContentComponent.defaultProps = {
  usingNewDesignSystem: false,
};

function mapStateToProps(state, ownProps) {
  const { notebook } = state;
  const usingNewDesignSystem = notebook?.usingNewDesignSystem ?? false;

  return {
    ...ownProps,
    usingNewDesignSystem,
  };
}

export const ProtocolSectionContent = connect(mapStateToProps)(
  ProtocolSectionContentComponent
);
